import {
  Fragment,
  useEffect,
  useState,
  useRef,
  useContext,
  createRef,
} from "react";
import stylesRequestData from "./index.module.css";
import SearchSelectElement from "../../../shared/form/SearchSelectElement";
import { post, put } from "../../../adapters/xhr/api";
import { getUnifiedDeclarationAllDetails } from "../../../adapters/apis/lookups/lookups";
import {
  validateEgyptianPhoneNumber,
  validateEmail,
  validateNationalIDWithoutAgeLimit,
  validateEgyptianPhoneNumberWithPhoneInput,
} from "../../../helpers/Validation";
import InputElement from "../../../shared/form/InputElement";
import stylesModal from "../../UnifiedTaxDeclaration/forms/formTypes/Modal.module.css";

import UnifiedTaxDeclarationContext from "../../../contexts/UnifiedTaxDeclarationProvider";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { validateRequired } from "../../../helpers/Validation";
import UserForm from "../forms/common/userForm";
import TaxPayerForm from "../forms/common/taxPayerForm";
import CommonAddressForm from "../forms/common/commonAddressForm";
import ResidentialForm from "../forms/formTypes/residentialForm";
import { previewAndDownloadAppealFile } from "../../../adapters/apis/taxAppeal/details";
import {
  validateBeforeSubmit,
  validatePhoneBeforeSubmit,
} from "../helpers/validationHelper";
import UserAndTaxPayerDetailFiles from "../forms/common/userAndTaxPayerDetailFiles";
import CommonTabs from "../commonTabsAndLists/commonTabs";
import CommonLists from "../commonTabsAndLists/commonLists";
import DeclerationInfo from "../forms/common/declerationInfo";
import IndustrialAndProductionFacilityForm from "../forms/formTypes/industrialAndProductionFacilityForm";
import PetroleumFacilityForm from "../forms/formTypes/petroleumFacilityForm";
import MineQuarryForm from "../forms/formTypes/mineQuarryForm";
import CommercialForm from "../forms/formTypes/commericalForm";
import AdministrativeForm from "../forms/formTypes/administrativeForm";
import ServiceUnitForm from "../forms/formTypes/serviceUnitForm";
import FixedInstallationForm from "../forms/formTypes/fixedInstallationForm";
import ServiceFacilityForm from "../forms/formTypes/serviceFacilityForm";
import VacantLandForm from "../forms/formTypes/vacantLandForm";
import HotelFacilitiesForm from "../forms/formTypes/hotelFaciltiesForm";
import infoIconSvg from "../../../assets/img/Icon-metro-info.svg";
import InfoPopover from "../../../shared/form/InfoPopover";
import { getMatchingBuildings } from "../../../components/UnifiedTaxDeclaration/helpers/commonValidation";
import Modal from "react-modal";

const UnifiedTaxDeclarationData = ({
  nationalIdFileInputRef,
  passportNumFileInputRef,
  commercialRegistrationNumberInputRef,
  taxNumberFileInputRef,
  otherEntityFileInputRef,
  validFields,
  setValidFields,
  unitOwnerTypeErrorMessage,
  setUnitOwnerTypeErrorMessage,
  setNewUserError,
  handlePreviewFile,
  backendError,
  setBackendError,
  submissionError,
  setSubmissionError,
  setTempFiles,
}) => {
  Modal.setAppElement("body");

  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    user,
    declarationRequest,
    updateDeclarationRequest,
    setDeclarationRequest,
    updateDeclarationUnit,
    isUnitInSameBuilding,
    setIsUnitInSameBuilding,
    getUnitInitialValue,
    setShowPropertyTypeModal,
    setPropertyTypes,
    setIsGoingToFetchDeclarationData,
    isGoingToFetchDeclarationData,
    getDeclerationDetails,
    resetDeclarationUnit,
    isSubmitting,
    setIsSubmitting,
    applicantRoles,
    nationalitiesTypes,
    govs,
    propertyTypes,
    taxpayerTypes,
    residentialUnitTypes,
    commericalUnitTypes,
    installationTypes,
    realFloorOther,
    unitAttachments,
    doYouWantExtraAttachments,
    declerationInitialValue,
    setError,
    error_new_user,
    setBuilding,
    setIsBuildingEditMode,
    clearAllUnitErrors,
    isBulkUpload,
    setIsBulkUpload,
    phoneError,
    setPhoneError,
  } = unifiedTaxDeclarationContext;

  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  // const nationalIdFileInputRef = useRef();
  // const passportNumFileInputRef = useRef();
  // const commercialRegistrationNumberInputRef = useRef();
  // const taxNumberFileInputRef = useRef();
  // const otherEntityFileInputRef = useRef();
  const mapInitializedRef = useRef(false);
  const documentFileInputRef = useRef({});
  const ownershipDeedFileInputRef = useRef({});
  const constructionLicenseFileInputRef = useRef({});
  const deedOfExploitationFileInputRef = useRef({});
  const landOwnershipLegalDocument = useRef({});
  const leaseContractFileInputRef = useRef({});
  const licenseCopyFileInputRef = useRef({});
  const operationLicenseFileInputRef = useRef({});
  const allocationContractFileInputRef = useRef({});
  const constructionPermitsFileInputRef = useRef({});
  const operatingLicensesFileInputRef = useRef({});
  const stardomCertificateFileInputRef = useRef({});

  const openingBudgetFileInputRef = useRef({});
  const allBookValueFileInputRef = useRef({});
  const articlesOfAssociationFileInputRef = useRef({});
  const [
    isButtonDisabledIfAttachmentFilesAreNotValid,
    setIsButtonDisabledIfAttachmentFilesAreNotValid,
  ] = useState(false);
  const [
    checkIfBuildingsFilterIsEqualToUnitFilterType,
    setCheckIfBuildingsFilterIsEqualToUnitFilterType,
  ] = useState("");

  const [uploadFileError, setUploadFileError] = useState(null);
  const [showDeleteSuccessMessage, setShowDeleteSuccessMessage] =
    useState(false);
  const [isValid, setIsValid] = useState(false);
  const [fileErrors, setFileErrors] = useState([]);

  const [floors, setFloors] = useState([]);
  const [units, setUnits] = useState([]);

  const [inputKeys, setInputKeys] = useState({});
  const [unitMapError, setUnitMapError] = useState("");
  const [unitBuildingMapError, setUnitBuildingMapError] = useState("");

  const [showModal, setShowModal] = useState(false);

  const [fileInputKeys, setFileInputKeys] = useState({
    ownership: Date.now(),
    ownership_deed: Date.now(),
    lease_contract: Date.now(),
    license_photo: Date.now(),
    agency: Date.now(),
    appeal: Date.now(),
    tax: Date.now(),
    construction_license: Date.now(),
    operating_licenses: Date.now(),
    allocation_contract: Date.now(),
    opening_budget: Date.now(),
    all_book_value: Date.now(),
    association_bylaws: Date.now(),
    deed_of_exploitation: Date.now(),
    facility_ownership_deed: Date.now(),
    facility_lease_contracts: Date.now(),
    building_permits: Date.now(),
    land_ownership_legal_document: Date.now(),
    land_lease_agreement: Date.now(),
    copy_of_the_construction_permits: Date.now(),
    copy_of_the_operating_licenses: Date.now(),
    certificate_of_stardom_level: Date.now(),
  });

  const nationalitesOptions = nationalitiesTypes?.map((element) => {
    return { value: element.id, label: element.name };
  });

  useEffect(() => {
    if (isGoingToFetchDeclarationData) {
      getDeclerationDetails();
    }
  }, [isGoingToFetchDeclarationData]);

  // useEffect(() => {
  //   if (parseInt(declarationRequest?.taxpayer?.nationality_id) === 63) {
  //     if (
  //       !validateRequired(
  //         declarationRequest?.taxpayer?.national_id_attachment?.full_url,
  //       )
  //     ) {
  //       setError("national_id_attachment", "يجب رفع مرفق الرقم القومي");
  //     } else {
  //       setError("national_id_attachment", "");
  //     }
  //   } else {
  //     if (
  //       !validateRequired(
  //         declarationRequest?.taxpayer?.passport_attachment?.full_url,
  //       )
  //     ) {
  //       setError("passport_attachment", "يجب رفع مرفق جواز السفر");
  //     } else {
  //       setError("passport_attachment", "");
  //     }
  //   }
  // }, [declarationRequest?.taxpayer?.nationality_id]);

  const handleAddressTypeChange = () => {
    setError("governorate_id", "");
    setError("district_id", "");
    setError("village_id", "");
    setError("village_other", "");
    setError("region_id", "");
    setError("region_other", "");
    setError("real_estate_id", "");
    setError("real_estate_other", "");
    setError("real_estate_floor_id", "");
    setError("unit_id", "");
    setError("unit_other", "");
    setError("real_estate_floor_other", "");

    setValidFields((prev) => ({
      ...prev,
      governorate_id: false,
      district_id: false,
      village_id: false,
      village_other: false,
      region_id: false,
      region_other: false,
      real_estate_id: false,
      real_estate_other: false,
      real_estate_floor_id: false,
      unit_id: false,
      unit_other: false,
      real_estate_floor_other: false,
    }));

    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        governorate_id: null,
        district_id: null,
        village_id: null,
        village_other: null,
        region_id: null,
        region_other: null,
        real_estate_id: null,
        real_estate_other: null,
        real_estate_floor_id: null,
        unit_id: null,
        unit_other: null,
        real_estate_floor_other: null,
      },
    }));
  };

  useEffect(() => {
    let currentDocuments = declarationRequest?.unit?.supporting_documents || [];
    if (
      parseInt(declarationRequest?.unit?.submit_other_supporting_documents) ===
      1
    ) {
      if (currentDocuments?.length === 0) {
        const singleAttachment = {
          id: Math.random(),
          name: null,
          file: null,
          original_file_name: null,
          path: null,
          full_url: null,
        };
        // setAttachments((prev) => [...prev, singleAttachment]);
        updateDeclarationUnit("supporting_documents", [
          ...(declarationRequest?.unit?.supporting_documents || []),
          singleAttachment,
        ]);
        setFileErrors((prev) => ({ ...prev, [singleAttachment.id]: "" }));
      }
    } else {
      // setAttachments([]);
      setIsButtonDisabledIfAttachmentFilesAreNotValid(false);
      updateDeclarationUnit("supporting_documents", []);
    }
  }, [declarationRequest?.unit?.submit_other_supporting_documents]);

  const addAttachment = () => {
    const newDoc = {
      id: Math.random(),
      name: null,
      file: null,
      original_file_name: null,
      path: null,
      full_url: null,
    };

    // setAttachments((prev) => [...prev, newDoc]);
    updateDeclarationUnit("supporting_documents", [
      ...(declarationRequest?.unit?.supporting_documents || []),
      newDoc,
    ]);
    setFileErrors((prev) => ({
      ...prev,
      [newDoc.id]: {
        name: "",
        file: "",
        original_file_name: "",
        path: "",
        full_url: "",
      },
    }));
  };

  const removeAttachmentById = (id) => {
    setIsButtonDisabledIfAttachmentFilesAreNotValid(false);
    // setAttachments((prev) => prev.filter((doc) => doc.id !== id));
    updateDeclarationUnit(
      "supporting_documents",
      (declarationRequest?.unit?.supporting_documents || []).filter(
        (doc) => doc.id !== id,
      ),
    );
    setFileErrors((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  const updateDocumentName = (id, newName) => {
    // setAttachments((prev) =>
    //   prev.map((item) => (item.id === id ? { ...item, name: newName } : item))
    // );
    updateDeclarationUnit(
      "supporting_documents",
      (declarationRequest?.unit?.supporting_documents || []).map((item) =>
        item.id === id ? { ...item, name: newName } : item,
      ),
    );
  };

  const updateDocumentFile = async (id, file, ref) => {
    try {
      setIsButtonDisabledIfAttachmentFilesAreNotValid(true);
      const data = new FormData();
      data.append(`label`, "supporting_documents");
      data.append(`file`, file);
      if (file) {
        const response = await post(
          "api/declaration-system/declarations/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );
        setIsButtonDisabledIfAttachmentFilesAreNotValid(false);

        updateDeclarationUnit(
          "supporting_documents",
          (declarationRequest?.unit?.supporting_documents || []).map((item) =>
            item.id === id
              ? {
                  ...item,
                  file: response?.data?.data?.file,
                  original_file_name: response?.data?.data?.original_file_name,
                  path: response?.data?.data?.path,
                  full_url: response?.data?.data?.full_url,
                }
              : item,
          ),
        );
        setUploadFileError(null);
        if (location?.pathname?.includes("add") && !declarationRequest?.id) {
          setTempFiles((prev) => [...prev, response?.data?.data?.path]);
        }
      }
    } catch (error) {
      setIsButtonDisabledIfAttachmentFilesAreNotValid(true);
      if (error.status === 422) {
        updateDeclarationUnit(
          "supporting_documents",
          (declarationRequest?.unit?.supporting_documents || []).map((item) =>
            item.id === id
              ? {
                  ...item,
                  file: null,
                  original_file_name: null,
                  path: null,
                  full_url: null,
                }
              : item,
          ),
        );
        window.scrollTo(0, 0);
        // setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
        if (ref?.current) {
          ref.current.value = null;
        }
      }
    }
  };

  const setFileErrorById = (id, field, message) => {
    setFileErrors((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: message,
      },
    }));
  };

  const validateAttachments = () => {
    const errors = {};

    declarationRequest?.unit?.supporting_documents?.forEach((doc) => {
      errors[doc.id] = {
        name:
          doc.name === null || doc.name === "" ? "يجب إدخال اسم المستند" : "",
        file: doc.file === null ? "يجب رفع الصورة" : "",
      };
    });

    setFileErrors(errors);
  };

  useEffect(() => {
    validateAttachments();
  }, [declarationRequest?.unit?.supporting_documents]);

  const scrollToElement = (element_name) => {
    const element = document.getElementById(element_name);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const handleDeleteUnitSuccess = () => {
    setShowDeleteSuccessMessage(true);
    setTimeout(() => {
      setShowDeleteSuccessMessage(false);
    }, 3000);
  };

  function handleChangeApplicantRole(parentCompenent, compenent, key, value) {
    handleChange(parentCompenent, compenent, key, value);

    updateDeclarationUnit("property_type_id", null);

    if (parseInt(value) !== 7) {
      setDeclarationRequest((prev) => ({
        ...prev,
        applicant_role_other: null,
      }));
      setValidFields((prev) => ({
        ...prev,
        applicant_role_other: true,
      }));
      setNewUserError((prev) => ({
        ...prev,
        applicant_role_other: "",
      }));
    }
    if ([1, 2, 3, 4].includes(parseInt(value))) {
      setDeclarationRequest((prev) => ({
        ...prev,
        power_of_attorney: null,
        joint_ownership_document: null,
        national_id_attachment: null,
        passport_attachment: null,
        commercial_register_attachment: null,
        tax_card_attachment: null,
        other_attachment: null,
      }));
      setValidFields((prev) => ({
        ...prev,
        power_of_attorney: true,
        joint_ownership_document: null,
        national_id_attachment: true,

        passport_attachment: true,
        commercial_register_attachment: true,
        tax_card_attachment: true,
        other_attachment: true,
      }));
      setNewUserError((prev) => ({
        ...prev,
        power_of_attorney: "",
        joint_ownership_document: "",
        national_id_attachment: "",
        passport_attachment: "",
        commercial_register_attachment: "",
        tax_card_attachment: "",
        other_attachment: "",
      }));
    } else {
      if (parseInt(value) === 2) {
        setValidFields((prev) => ({
          ...prev,
          joint_ownership_document: false,
        }));
      }
      if ([5, 6, 7].includes(parseInt(value))) {
        setValidFields((prev) => ({
          ...prev,
          power_of_attorney: false,
        }));
      }
    }
  }

  const handleNationalityChange = () => {
    setError("national_id", "");
    setError("national_id_attachment", "");
    setError("passport_number", "");
    setError("passport_attachment", "");
    setValidFields((prev) => ({
      ...prev,
      national_id: false,
      national_id_attachment: false,
      passport_number: false,
      passport_attachment: false,
    }));
    setDeclarationRequest((prev) => ({
      ...prev,
      taxpayer: {
        ...prev.taxpayer,
        national_id: null,
        passport_number: null,
        national_id_attachment: null,
        passport_attachment: null,
        country_code: "eg",
        dial_code: "20",
        phone: "20",
      },
    }));
    if (nationalIdFileInputRef?.current) {
      nationalIdFileInputRef.current.value = null;
    }
    if (passportNumFileInputRef?.current) {
      passportNumFileInputRef.current.value = null;
    }
  };

  const handleTypeOneChange = () => {
    setError("first_name", "");
    setError("last_name", "");
    setError("nationality_id", "");
    setError("phone", "");
    setError("email", "");
    setError("nationality_id", "");

    setValidFields((prev) => ({
      ...prev,
      first_name: false,
      last_name: false,
      nationality_id: false,
      phone: false,
      name: false,
      email: false,
      nationality_id: false,
    }));
    setDeclarationRequest((prev) => ({
      ...prev,
      taxpayer: {
        ...prev.taxpayer,
        nationality_id: null,
        first_name: null,
        last_name: null,
        nationality_id: null,
        phone: "20",
        email: null,
        country_code: "eg",
        dial_code: "20",
      },
    }));

    handleNationalityChange();
  };

  const handleTypeTwoChange = () => {
    setError("name", "");
    setError("commercial_register", "");
    setError("commercial_register_attachment", "");
    setError("tax_card_number", "");
    setError("tax_card_attachment", "");
    setError("other_attachment_name", "");
    setError("other_attachment", "");
    setError("phone", "");
    setError("email", "");

    setValidFields((prev) => ({
      ...prev,
      name: false,
      commercial_register: false,
      commercial_register_attachment: false,
      tax_card_number: false,
      tax_card_attachment: false,
      other_attachment_name: false,
      other_attachment: false,
      phone: false,
      email: false,
    }));
    setDeclarationRequest((prev) => ({
      ...prev,
      taxpayer: {
        ...prev.taxpayer,
        name: null,
        commercial_register: null,
        commercial_register_attachment: null,
        tax_card_number: null,
        tax_card_attachment: null,
        other_attachment_name: null,
        other_attachment: null,
        phone: "20",
        email: null,
        country_code: "eg",
        dial_code: "20",
      },
    }));

    if (commercialRegistrationNumberInputRef?.current) {
      commercialRegistrationNumberInputRef.current.value = null;
    }
    if (taxNumberFileInputRef?.current) {
      taxNumberFileInputRef.current.value = null;
    }
    if (otherEntityFileInputRef?.current) {
      otherEntityFileInputRef.current.value = null;
    }
  };

  // useEffect(()=>{},[])

  function handleChange(pc, c, key, value) {
    if (key === "applicant_role_id") {
      setError("type_id", "");
      setValidFields((prev) => ({
        ...prev,
        type_id: false,
      }));

      setDeclarationRequest((prev) => ({
        ...prev,
        taxpayer: {
          ...prev.taxpayer,
          type_id: null,
        },
      }));
      handleTypeOneChange();
      handleTypeTwoChange();
    }

    setDeclarationRequest((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  const handleChangeFile = async (pc, c, key, value) => {
    try {
      // setError(key, "");

      const data = new FormData();
      data.append(`label`, key);
      data.append(`file`, value);

      if (value) {
        const response = await post(
          "api/declaration-system/declarations/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        setDeclarationRequest((prev) => ({
          ...prev,
          [key]: response?.data?.data,
        }));
        setError(key, "");
        setUploadFileError(null);
        if (location?.pathname?.includes("add") && !declarationRequest?.id) {
          setTempFiles((prev) => [...prev, response?.data?.data?.path]);
        }
      }
    } catch (error) {
      if (error.status === 422) {
        setValidFields((prev) => ({
          ...prev,
          key: false,
        }));
        setDeclarationRequest((prev) => ({
          ...prev,
          [key]: null,
        }));
        window.scrollTo(0, 0);
        setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
      }
    }
  };

  const handleRemoveFileForAdditionalAttachment = (id) => {
    setInputKeys((prev) => ({
      ...prev,
      [id]: (prev?.[id] ?? 0) + 0.1,
    }));

    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        supporting_documents: (prev?.unit?.supporting_documents ?? []).map(
          (item) =>
            item.id === id
              ? {
                  ...item,
                  file: null,
                  full_url: null,
                  original_file_name: null,
                  path: null,
                }
              : item,
        ),
      },
    }));
  };

  const resetUnit = () => {
    setUnits([]);

    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        unit_id: null,
        unit_other: null,
      },
    }));
    setNewUserError((prev) => ({
      ...prev,
      unit_id: "",
      unit_other: "",
    }));
  };

  const disableSubmitButtonCheck = () => {
    let isButtonDisabled = false;
    if (
      parseInt(declarationRequest?.unit?.submit_other_supporting_documents) ===
      1
    ) {
      isButtonDisabled = Object.values(fileErrors).some(
        (error) => error.name !== "" || error.file !== "",
      );
    }
    if (declarationRequest?.unit?.supporting_documents?.length > 5) {
      isButtonDisabled = true;
    }
    if (isSubmitting) {
      isButtonDisabled = true;
    }

    if (
      parseInt(declarationRequest?.unit?.property_type_id) === 6 &&
      parseInt(declarationRequest?.unit?.has_sub_units) === 1
    ) {
      if (
        !Array.isArray(declarationRequest?.unit?.hotelUnits) ||
        declarationRequest?.unit?.hotelUnits.length === 0
      ) {
        isButtonDisabled = true;
      }
    }

    if (
      !validateRequired(
        declarationRequest?.joint_ownership_document?.full_url,
      ) &&
      parseInt(declarationRequest?.applicant_role_id) === 2
    ) {
      isButtonDisabled = true;
    }

    if ([5, 6, 7].includes(parseInt(declarationRequest?.applicant_role_id))) {
      if (!validateRequired(declarationRequest?.power_of_attorney?.full_url)) {
        isButtonDisabled = true;
      }

      if (parseInt(declarationRequest?.taxpayer?.type_id) === 1) {
        if (parseInt(declarationRequest?.taxpayer?.nationality_id) === 63) {
          if (
            !validateRequired(
              declarationRequest?.taxpayer?.national_id_attachment?.full_url,
            )
          ) {
            isButtonDisabled = true;
          }
        }

        if (
          declarationRequest?.taxpayer?.nationality_id !== null &&
          parseInt(declarationRequest?.taxpayer?.nationality_id) !== 63
        ) {
          if (
            !validateRequired(
              declarationRequest?.taxpayer?.passport_attachment?.full_url,
            )
          ) {
            isButtonDisabled = true;
          }
        }
      }

      if (parseInt(declarationRequest?.taxpayer?.type_id) === 2) {
        if (
          validateRequired(declarationRequest?.taxpayer?.commercial_register)
        ) {
          if (
            !validateRequired(
              declarationRequest?.taxpayer?.commercial_register_attachment
                ?.full_url,
            )
          ) {
            isButtonDisabled = true;
          }
        }

        if (validateRequired(declarationRequest?.taxpayer?.tax_card_number)) {
          if (
            !validateRequired(
              declarationRequest?.taxpayer?.tax_card_attachment?.full_url,
            )
          ) {
            isButtonDisabled = true;
          }
        }

        if (
          validateRequired(declarationRequest?.taxpayer?.other_attachment_name)
        ) {
          if (
            !validateRequired(
              declarationRequest?.taxpayer?.other_attachment?.full_url,
            )
          ) {
            isButtonDisabled = true;
          }
        }
      }
    }

    if (parseInt(declarationRequest?.applicant_role_id) === 2) {
      if (parseInt(declarationRequest?.taxpayer?.nationality_id) === 63) {
        if (
          !validateRequired(
            declarationRequest?.taxpayer?.national_id_attachment?.full_url,
          )
        ) {
          isButtonDisabled = true;
        }
      }

      if (
        declarationRequest?.taxpayer?.nationality_id !== null &&
        parseInt(declarationRequest?.taxpayer?.nationality_id) !== 63
      ) {
        if (
          !validateRequired(
            declarationRequest?.taxpayer?.passport_attachment?.full_url,
          )
        ) {
          isButtonDisabled = true;
        }
      }
    }

    if (
      [5, 7, 8, 9].includes(
        parseInt(declarationRequest?.unit?.property_type_id),
      )
    ) {
      if (
        !Array.isArray(declarationRequest?.unit?.buildings) ||
        declarationRequest?.unit?.buildings?.length === 0 ||
        declarationRequest?.unit?.buildings_count === "" ||
        declarationRequest?.unit?.buildings_count === null ||
        declarationRequest?.unit?.buildings_count === undefined ||
        declarationRequest?.unit?.buildings?.length >
          parseInt(declarationRequest?.unit?.buildings_count || 1)
      ) {
        isButtonDisabled = true;
      }

      // if (
      //   // !Array.isArray(declarationRequest?.unit?.buildings) ||
      //   declarationRequest?.unit?.buildings?.length === 0 ||
      //   declarationRequest?.unit?.buildings_count === "" ||
      //   declarationRequest?.unit?.buildings_count === null ||
      //   declarationRequest?.unit?.buildings_count === undefined
      // ) {
      //   isButtonDisabled = true;
      // }
    }

    if (
      [5, 6, 7, 8, 9].includes(
        parseInt(declarationRequest?.unit?.property_type_id),
      )
    ) {
      if (
        declarationRequest?.unit?.buildings === undefined ||
        parseInt(declarationRequest?.unit?.buildings[0]?.filter_search_type) !==
          parseInt(declarationRequest?.unit?.filter_search_type_id)
      ) {
        isButtonDisabled = true;
      } else {
        isButtonDisabled = false;
      }
    }

    if (parseInt(declarationRequest?.unit?.property_type_id) === 6) {
      if (
        parseInt(declarationRequest?.unit?.has_sub_units) === 1 &&
        (!Array.isArray(declarationRequest?.unit?.hotelUnits) ||
          declarationRequest?.unit?.hotelUnits?.length < 1)
      ) {
        isButtonDisabled = true;
      }
    }

    if (parseInt(declarationRequest?.unit?.property_type_id) === 12) {
      if (
        !Array.isArray(declarationRequest?.unit?.vacantLands) ||
        declarationRequest?.unit?.vacantLands?.length < 1
      ) {
        isButtonDisabled = true;
      }

      if (
        (declarationRequest?.unit?.vacantLands ?? []).reduce(
          (s, x) => s + parseFloat(x?.used_land_area || 0),
          0,
        ) > parseFloat(declarationRequest?.unit?.total_land_area)
      ) {
        isButtonDisabled = true;
      }
    }

    if (
      [7, 8, 9].includes(parseInt(declarationRequest?.unit?.property_type_id))
    ) {
      if (
        parseInt(declarationRequest?.unit?.used_land_area) >
        parseInt(declarationRequest?.unit?.total_land_area)
      ) {
        isButtonDisabled = true;
      }
    }
    return isButtonDisabled;
  };

  const handleSubmitUnit = async (e) => {
    window.scrollTo(0, 0);
    e.preventDefault();
    const keepSameBuildingUI = Boolean(isUnitInSameBuilding);
    setIsUnitInSameBuilding(keepSameBuildingUI);

    setBackendError(null);
    setSubmissionError(null);
    setUploadFileError(null);

    if (declarationRequest?.unit?.buildings?.length > 0) {
      declarationRequest?.unit?.buildings?.map((item) => {
        if (item.id < 1) {
          delete item.id;
        }
      });
    }
    setDeclarationRequest({
      ...declarationRequest,
      isDeclarationSameUnit: false,
    });

    await handleCommonUnitSubmit(false, keepSameBuildingUI);
  };

  const handleSubmitSameUnit = async (e) => {
    window.scrollTo(0, 0);
    e.preventDefault();

    setBackendError(null);
    setSubmissionError(null);
    setUploadFileError(null);
    setDeclarationRequest({
      ...declarationRequest,
      isDeclarationSameUnit: true,
    });

    await handleCommonUnitSubmit(true, true);
  };

  const handleGetActiveTabBasedOnPropertyTypeId = () => {
    switch (parseInt(declarationRequest?.unit?.property_type_id)) {
      case 1:
        return "residential";

      // case 2:
      //   return <ComponentB />;

      // case 3:
      //   return <ComponentC />;

      // case 4:
      //   return <ComponentB />;

      // case 5:
      //   return <ComponentC />;

      // case 6:
      //   return <ComponentB />;

      case 7:
        return "industrial_facility";

      case 8:
        return "production_facility";

      case 9:
        return "petroleum_facility";

      case 10:
        return "mine_quarry";

      case 11:
        return "fixed_installation";

      case 12:
        return "vacant_land";

      default:
        return "residential";
    }
  };

  const mergeHotelUnitsIntoBuildings = (buildings = [], hotelUnits = []) => {
    return buildings.map((building) => {
      const relatedUnits = hotelUnits.filter(
        (unit) => unit.building_id == building.id,
      );

      return {
        ...building,
        hotelUnits: relatedUnits, // attach all hotelUnits belonging to this building
      };
    });
  };

  useEffect(() => {
    setBackendError(null);
    setSubmissionError(null);
    setUploadFileError(null);
  }, [
    declarationRequest?.isShowOnlyUnit,
    declarationRequest?.isUnitEditMode,
    declarationRequest?.isUnitViewMode,
  ]);

  const sanitizeDeclarationRequest = (newDeclarationRequest) => {
    delete declarationRequest.fixed_installation;
    delete declarationRequest.hotel_facility;
    delete declarationRequest.industrial_facility;
    delete declarationRequest.mine_quarry;
    delete declarationRequest.petroleum_facility;
    delete declarationRequest.production_facility;
    delete declarationRequest.residential_units;
    delete declarationRequest.service_facilities;
    delete declarationRequest.service_units;
    delete declarationRequest.units_count;
    delete declarationRequest.vacant_land;

    if (
      declarationRequest?.taxpayer?.phone == "+20" ||
      declarationRequest?.taxpayer?.phone == "20" ||
      declarationRequest?.taxpayer?.phone ===
        declarationRequest?.taxpayer?.dial_code
    ) {
      newDeclarationRequest.taxpayer.phone = null;
    }
  };

  const handleCommonUnitSubmit = async (
    isSameUnit,
    keepSameBuildingUI = isSameUnit,
  ) => {
    let isManualValid = true;
    let newDeclarationRequest = { ...declarationRequest };
    sanitizeDeclarationRequest(newDeclarationRequest);

    const currentActiveTab = handleGetActiveTabBasedOnPropertyTypeId();
    const accountCode = declarationRequest?.unit?.account_code?.trim();
    if (validateRequired(accountCode) && !/^\d{14}$/.test(accountCode)) {
      setError("account_code", "كود حساب الوحدة يجب ان يكون 14 رقم");
      setValidFields((prev) => ({ ...prev, account_code: false }));
      setIsSubmitting(false);
      return;
    }
    if (!validateRequired(accountCode)) {
      setError("account_code", "");
      setValidFields((prev) => ({ ...prev, account_code: true }));
    }

    if (parseInt(declarationRequest?.unit?.property_type_id) === 6) {
      const mergedBuildings = mergeHotelUnitsIntoBuildings(
        getMatchingBuildings(declarationRequest),
        declarationRequest?.unit?.hotelUnits,
      );

      declarationRequest.unit.buildings = mergedBuildings;
    }

    const isFormValid = validateBeforeSubmit(
      declarationRequest,
      validateRequired,
      setValidFields,
      setError,
      validateNationalIDWithoutAgeLimit,
      setUnitOwnerTypeErrorMessage,
    );

    if (parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3) {
      if (unitMapError !== "" || unitBuildingMapError !== "") {
        return;
      }
      if (!validateRequired(declarationRequest?.unit?.buildingProfile?.renin)) {
        return setUnitMapError("هذا العقار غير متاح برجاء اختيار عقار آخر");
      }

      if (
        !validateRequired(declarationRequest?.unit?.is_map_address_matching)
      ) {
        setValidFields((prev) => ({
          ...prev,
          is_map_address_matching: false,
        }));
        return setError("is_map_address_matching", "يجب اختيار إجابة");
      } else {
        // Rule 2: if no known_build_num AND is_map_address_matching === 1 → special error
        if (
          !validateRequired(
            declarationRequest?.unit?.buildingProfile?.number,
          ) &&
          parseInt(declarationRequest?.unit?.is_map_address_matching) === 1
        ) {
          setValidFields((prev) => ({
            ...prev,
            is_map_address_matching: false,
          }));
          return setError(
            "is_map_address_matching",
            "لا يمكن الإستمرار بالإجابة “نعم” لعدم توفر رقم العقار، برجاء تصحيح البيانات و إدخال رقم العقار/المبنى المتعارف عليه",
          );
        } else {
          // If known_build_num is provided, clear its error
          setValidFields((prev) => ({
            ...prev,
            is_map_address_matching: true,
          }));
          setError("is_map_address_matching", "");
        }
      }

      if (parseInt(declarationRequest?.unit?.is_map_address_matching) === 2) {
        if (!validateRequired(declarationRequest?.unit?.mismatch_reason_id)) {
          setValidFields((prev) => ({
            ...prev,
            mismatch_reason_id: false,
          }));
          return setError("mismatch_reason_id", "يجب اختيار إجابة");
        } else {
          setError("mismatch_reason_id", "");
          setValidFields((prev) => ({
            ...prev,
            mismatch_reason_id: true,
          }));
        }
      }

      // Check both buildingProfile.number and known_build_num together
      if (
        !validateRequired(declarationRequest?.unit?.buildingProfile?.number) &&
        !validateRequired(declarationRequest?.unit?.known_build_num)
      ) {
        setValidFields((prev) => ({
          ...prev,
          known_build_num: false,
        }));

        return setError(
          "known_build_num",
          "يجب إدخال رقم العقار/المبنى المتعارف عليه",
        );
      } else {
        // At least one of them exists → clear error
        setError("known_build_num", "");
        setValidFields((prev) => ({
          ...prev,
          known_build_num: true,
        }));
      }
    } else {
      if (!validateRequired(declarationRequest?.unit?.manual_governorate_id)) {
        setValidFields((prev) => ({
          ...prev,
          manual_governorate_id: false,
        }));
        setError("manual_governorate_id", "يجب إختيار المحافظة");
        isManualValid = false;
      } else {
        setError("manual_governorate_id", "");
        setValidFields((prev) => ({
          ...prev,
          manual_governorate_id: true,
        }));
      }

      if (
        !validateRequired(declarationRequest?.unit?.manual_policestation_id)
      ) {
        setValidFields((prev) => ({
          ...prev,
          manual_policestation_id: false,
        }));
        setError("manual_policestation_id", "يجب إختيار قسم/مركز الشرطة");
        isManualValid = false;
      } else {
        setError("manual_policestation_id", "");
        setValidFields((prev) => ({
          ...prev,
          manual_policestation_id: true,
        }));
      }

      if (!validateRequired(declarationRequest?.unit?.manual_known_build_num)) {
        setValidFields((prev) => ({
          ...prev,
          manual_known_build_num: false,
        }));
        setError(
          "manual_known_build_num",
          "يجب إدخال رقم العقار/المبنى كما هو متعارف عليه",
        );
        isManualValid = false;
      } else {
        setError("manual_known_build_num", "");
        setValidFields((prev) => ({
          ...prev,
          manual_known_build_num: true,
        }));
      }
    }

    setUnitMapError("");
    setIsSubmitting(false);

    const isValidPhone = validatePhoneBeforeSubmit(
      declarationRequest?.taxpayer?.phone || "20",
      declarationRequest?.taxpayer?.dial_code,
      declarationRequest?.taxpayer?.country_code,
      setPhoneError,
      declarationRequest?.taxpayer?.type_id,
      declarationRequest?.applicant_role_id,
      declarationRequest?.taxpayer?.nationality_id,
    );

    try {
      if (parseInt(declarationRequest?.taxpayer?.type_id) === 2) {
        declarationRequest.taxpayer.nationality_id = null;
      }
      let response;
      if (isFormValid && isManualValid && phoneError === null && isValidPhone) {
        setIsSubmitting(true);
        let url = `api/declaration-system/declarations${isSameUnit ? "?isSameUnit=true" : ""}`;

        if (declarationRequest?.id) {
          url = `api/declaration-system/declarations/${declarationRequest?.id}${isSameUnit ? "?isSameUnit=true" : ""}`;
        }
        // update
        if (
          // location.pathname.includes(`/tax-declaration/update`) &&
          declarationRequest?.id
        ) {
          url = `api/declaration-system/declarations/${declarationRequest?.id}${isSameUnit ? "?isSameUnit=true" : ""}`;

          response = await put(
            url,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            },
            newDeclarationRequest,
          );
          setIsSubmitting(false);
          setIsUnitInSameBuilding(keepSameBuildingUI);
          if (isSameUnit) {
            const savedId = response?.data?.data?.id;
            const currentRenin =
              declarationRequest?.unit?.buildingProfile?.renin;
            let foundColour = null;
            try {
              if (savedId) {
                const detailsRes = await getUnifiedDeclarationAllDetails(
                  `api/declaration-system/declarations/${savedId}?for_edit=true`,
                );
                const allListKeys = [
                  "residential_units",
                  "commercial_units",
                  "administrative_units",
                  "service_units",
                  "service_facilities",
                  "hotel_facility",
                  "industrial_facility",
                  "production_facility",
                  "mine_quarry",
                  "petroleum_facility",
                  "fixed_installation",
                  "vacant_land",
                ];
                for (const key of allListKeys) {
                  const list = detailsRes?.data?.data?.[key]?.data || [];
                  const match = list.find(
                    (u) =>
                      String(u?.buildingProfile?.renin) ===
                      String(currentRenin),
                  );
                  if (match?.correct_astrick_colour) {
                    foundColour = match.correct_astrick_colour;
                    break;
                  }
                }
                setDeclarationRequest((prev) => ({
                  ...response?.data?.data,
                  ...detailsRes?.data?.data,
                  unit: {
                    ...response?.data?.data?.unit,
                    correct_astrick_colour:
                      foundColour || prev?.unit?.correct_astrick_colour,
                  },
                  isUnitEditMode: false,
                  isShowOnlyUnit: true,
                  isDeclarationSameUnit: true,
                  activeTab: currentActiveTab,
                }));
              }
            } catch {
              setDeclarationRequest((prev) => ({
                ...prev,
                ...response?.data?.data,
                unit: { ...prev?.unit },
                isUnitEditMode: false,
                isShowOnlyUnit: true,
                isDeclarationSameUnit: true,
                activeTab: currentActiveTab,
              }));
            }
            setShowPropertyTypeModal(true);
            setPropertyTypes(response?.data?.data?.PropertyTypes);
          } else {
            setDeclarationRequest({
              ...response?.data?.data,
              // Don't forget to set these values
              // (front related, they don't exist in response)
              isUnitEditMode: false,
              isShowOnlyUnit: false,
              isDeclarationSameUnit: false,
              activeTab: currentActiveTab,
            });
            navigate(
              `/tax-declaration/update/${response?.data?.data?.id || id}`,
            );
          }
        }
        // create
        else {
          response = await post(
            url,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            },
            newDeclarationRequest,
          );
          setIsUnitInSameBuilding(keepSameBuildingUI);
          if (isSameUnit) {
            const savedId = response?.data?.data?.id;
            const currentRenin =
              declarationRequest?.unit?.buildingProfile?.renin;
            let foundColour = null;
            try {
              if (savedId) {
                const detailsRes = await getUnifiedDeclarationAllDetails(
                  `api/declaration-system/declarations/${savedId}?for_edit=true`,
                );
                const allListKeys = [
                  "residential_units",
                  "commercial_units",
                  "administrative_units",
                  "service_units",
                  "fixed_installation",
                ];
                for (const key of allListKeys) {
                  const list = detailsRes?.data?.data?.[key]?.data || [];
                  const match = list.find(
                    (u) =>
                      String(u?.buildingProfile?.renin) ===
                      String(currentRenin),
                  );
                  if (match?.correct_astrick_colour) {
                    foundColour = match.correct_astrick_colour;
                    break;
                  }
                }
                setDeclarationRequest((prev) => ({
                  ...response?.data?.data,
                  ...detailsRes?.data?.data,
                  unit: {
                    ...prev?.unit,
                    correct_astrick_colour:
                      foundColour || prev?.unit?.correct_astrick_colour,
                  },
                  // Keep current details until modal confirmation
                  isUnitViewMode: false,
                  isUnitEditMode: true,
                  isShowOnlyUnit: true,
                  isDeclarationSameUnit: true,
                  activeTab: currentActiveTab,
                }));
              }
            } catch {
              setDeclarationRequest((prev) => ({
                ...prev,
                ...response?.data?.data,
                unit: { ...prev?.unit },
                // Keep current details until modal confirmation
                isUnitViewMode: false,
                isUnitEditMode: true,
                isShowOnlyUnit: true,
                isDeclarationSameUnit: true,
                activeTab: currentActiveTab,
              }));
            }
            setShowPropertyTypeModal(true);
            setPropertyTypes(response?.data?.data?.PropertyTypes);
          } else {
            setDeclarationRequest({
              ...response?.data?.data,
              // Don't forget to set these values
              // (front related, they don't exist in response)
              isUnitViewMode: false,
              isUnitEditMode: false,
              isShowOnlyUnit: false,
              isDeclarationSameUnit: false,
              activeTab: currentActiveTab,
            });
            navigate(`/tax-declaration/update/${response?.data?.data?.id}`);
          }
        }

        setIsSubmitting(false);
      }
    } catch (error) {
      setIsSubmitting(false);

      if (error.response?.data?.errors) {
        setSubmissionError(error.response?.data?.errors);
      } else {
        setBackendError(
          error.response?.data?.message ||
            error.response?.data?.data?.message ||
            "خطأ في إرسال البيانات",
        );
      }

      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    const allValid = Object.values(validFields).every(Boolean);
    setIsValid(allValid);
  }, [validFields]);
  // Generate options for select components
  const generateOptions = (data) =>
    data?.map(({ id, name }) => ({ value: id.toString(), label: name }));

  const generateOptionsWithActive = (data) =>
    data?.map(({ id, name, active }) => ({
      value: id.toString(),
      label: name,
      isDisabled: !active,
    }));

  useEffect(() => {
    (declarationRequest?.unit?.supporting_documents || [])?.forEach(
      (document) => {
        if (!documentFileInputRef.current[document.id]) {
          documentFileInputRef.current[document.id] = createRef();
        }
      },
    );
  }, [declarationRequest?.unit?.supporting_documents]);

  const handleChangeDeclerationUnit = (pc, c, key, value) => {
    setError(key, "");
    const integerFields = new Set([
      "reta_contact_about_unit",
      "submit_other_supporting_documents",
    ]);

    const normalizedValue =
      integerFields.has(key) &&
      value !== "" &&
      value !== null &&
      value !== undefined
        ? Number.parseInt(value, 10)
        : value;

    setValidFields((prev) => ({
      ...prev,
      [key]: true,
    }));
    if (key === "property_type_id") {
      setShowPropertyTypeModal(false);
    }
    if (key === "reta_contact_about_unit") {
      updateDeclarationUnit("account_code", null);
    }
    if (key === "unit_id") {
      setDeclarationRequest((prev) => ({
        ...prev,
        unit: {
          ...prev.unit,
          unit_other: null,
        },
      }));
      setNewUserError((prev) => ({
        ...prev,
        unit_other: "",
      }));
    }
    updateDeclarationUnit(key, normalizedValue);
  };

  const handleDownloadFile = async (url) => {
    try {
      const response = await previewAndDownloadAppealFile(url);

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      // Extract filename from Content-Disposition header
      let fileName = "file"; // Default filename
      let originFileName = "file";
      const disposition = response.headers["content-disposition"];
      if (disposition) {
        const match = disposition.match(/filename="(.+?)"/);
        if (match) {
          originFileName = match[1];
        }
      }

      const mimeType = blob.type;
      const ext = originFileName.split(".").pop().toLowerCase();

      if (ext === "jfif" || mimeType === "image/jfif") {
        fileName = "file.jfif";
      } else if (mimeType === "image/jpeg" || mimeType === "image/jpg") {
        fileName = ext === "jpg" ? "file.jpg" : "file.jpeg";
      }

      // Create a download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName.replace(/"/g, ""); // Remove any quotes
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };

  const hasUnitAddress = declarationRequest?.unit?.buildingProfile?.renin;

  useEffect(() => {
    if (
      !hasUnitAddress &&
      parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3
    ) {
      setFloors([]);
      setUnits([]);

      setDeclarationRequest((prev) => ({
        ...prev,
        unit: {
          ...prev.unit,
          real_estate_floor_id: null,
          unit_number: null,
        },
      }));
    }
  }, [hasUnitAddress]);

  const renderRemainingFormBasedOnPropertyType = () => {
    switch (parseInt(declarationRequest?.unit?.property_type_id)) {
      case 1:
        return (
          <ResidentialForm
            generateOptions={generateOptions}
            residentialUnitTypes={residentialUnitTypes}
            unitAttachments={unitAttachments}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            setDeclarationRequest={setDeclarationRequest}
            ownershipDeedFileInputRef={ownershipDeedFileInputRef}
            leaseContractFileInputRef={leaseContractFileInputRef}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            setTempFiles={setTempFiles}
          />
        );

      case 2:
        return (
          <CommercialForm
            generateOptions={generateOptions}
            commericalUnitTypes={commericalUnitTypes}
            unitAttachments={unitAttachments}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            setDeclarationRequest={setDeclarationRequest}
            ownershipDeedFileInputRef={ownershipDeedFileInputRef}
            leaseContractFileInputRef={leaseContractFileInputRef}
            licenseCopyFileInputRef={licenseCopyFileInputRef}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            setTempFiles={setTempFiles}
          />
        );

      case 3:
        return (
          <AdministrativeForm
            generateOptions={generateOptions}
            administrativeUnitTypes={commericalUnitTypes}
            unitAttachments={unitAttachments}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            setDeclarationRequest={setDeclarationRequest}
            ownershipDeedFileInputRef={ownershipDeedFileInputRef}
            leaseContractFileInputRef={leaseContractFileInputRef}
            licenseCopyFileInputRef={licenseCopyFileInputRef}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            setTempFiles={setTempFiles}
          />
        );

      case 4:
        return (
          <ServiceUnitForm
            generateOptions={generateOptions}
            serviceUnitTypes={commericalUnitTypes}
            unitAttachments={unitAttachments}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            setDeclarationRequest={setDeclarationRequest}
            ownershipDeedFileInputRef={ownershipDeedFileInputRef}
            leaseContractFileInputRef={leaseContractFileInputRef}
            licenseCopyFileInputRef={licenseCopyFileInputRef}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            setTempFiles={setTempFiles}
          />
        );

      case 5:
        return (
          <ServiceFacilityForm
            generateOptions={generateOptions}
            residentialUnitTypes={residentialUnitTypes}
            unitAttachments={unitAttachments}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            ownershipDeedFileInputRef={ownershipDeedFileInputRef}
            leaseContractFileInputRef={leaseContractFileInputRef}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            constructionLicenseFileInputRef={constructionLicenseFileInputRef}
            operationLicenseFileInputRef={operationLicenseFileInputRef}
            openingBudgetFileInputRef={openingBudgetFileInputRef}
            allBookValueFileInputRef={allBookValueFileInputRef}
            articlesOfAssociationFileInputRef={
              articlesOfAssociationFileInputRef
            }
            setBackendError={setBackendError}
            setSubmissionError={setSubmissionError}
            setTempFiles={setTempFiles}
            unitBuildingMapError={unitBuildingMapError}
            setUnitBuildingMapError={setUnitBuildingMapError}
            unitMapError={unitMapError}
            setUnitMapError={setUnitMapError}
          />
        );

      case 6:
        return (
          <HotelFacilitiesForm
            generateOptions={generateOptions}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            constructionPermitsFileInputRef={constructionPermitsFileInputRef}
            operatingLicensesFileInputRef={operatingLicensesFileInputRef}
            stardomCertificateFileInputRef={stardomCertificateFileInputRef}
            doYouWantExtraAttachments={doYouWantExtraAttachments}
            setBackendError={setBackendError}
            setSubmissionError={setSubmissionError}
            setTempFiles={setTempFiles}
            unitBuildingMapError={unitBuildingMapError}
            setUnitBuildingMapError={setUnitBuildingMapError}
          />
        );

      // case 6:
      //   return <ComponentB />;

      case 7:
        return (
          <IndustrialAndProductionFacilityForm
            generateOptions={generateOptions}
            residentialUnitTypes={residentialUnitTypes}
            unitAttachments={unitAttachments}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            ownershipDeedFileInputRef={ownershipDeedFileInputRef}
            leaseContractFileInputRef={leaseContractFileInputRef}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            constructionLicenseFileInputRef={constructionLicenseFileInputRef}
            operationLicenseFileInputRef={operationLicenseFileInputRef}
            allocationContractFileInputRef={allocationContractFileInputRef}
            setBackendError={setBackendError}
            setSubmissionError={setSubmissionError}
            setTempFiles={setTempFiles}
            mapInitializedRef={mapInitializedRef}
            unitBuildingMapError={unitBuildingMapError}
            setUnitBuildingMapError={setUnitBuildingMapError}
            unitMapError={unitMapError}
            setUnitMapError={setUnitMapError}
          />
        );

      case 8:
        return (
          <IndustrialAndProductionFacilityForm
            generateOptions={generateOptions}
            residentialUnitTypes={residentialUnitTypes}
            unitAttachments={unitAttachments}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            ownershipDeedFileInputRef={ownershipDeedFileInputRef}
            leaseContractFileInputRef={leaseContractFileInputRef}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            constructionLicenseFileInputRef={constructionLicenseFileInputRef}
            operationLicenseFileInputRef={operationLicenseFileInputRef}
            allocationContractFileInputRef={allocationContractFileInputRef}
            setBackendError={setBackendError}
            setSubmissionError={setSubmissionError}
            setTempFiles={setTempFiles}
            unitBuildingMapError={unitBuildingMapError}
            setUnitBuildingMapError={setUnitBuildingMapError}
            unitMapError={unitMapError}
            setUnitMapError={setUnitMapError}
          />
        );

      case 9:
        return (
          <PetroleumFacilityForm
            generateOptions={generateOptions}
            residentialUnitTypes={residentialUnitTypes}
            unitAttachments={unitAttachments}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            ownershipDeedFileInputRef={ownershipDeedFileInputRef}
            leaseContractFileInputRef={leaseContractFileInputRef}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            constructionLicenseFileInputRef={constructionLicenseFileInputRef}
            openingBudgetFileInputRef={openingBudgetFileInputRef}
            allBookValueFileInputRef={allBookValueFileInputRef}
            setBackendError={setBackendError}
            setSubmissionError={setSubmissionError}
            setTempFiles={setTempFiles}
            unitBuildingMapError={unitBuildingMapError}
            setUnitBuildingMapError={setUnitBuildingMapError}
            unitMapError={unitMapError}
            setUnitMapError={setUnitMapError}
          />
        );

      case 10:
        return (
          <MineQuarryForm
            generateOptions={generateOptions}
            residentialUnitTypes={residentialUnitTypes}
            unitAttachments={unitAttachments}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            deedOfExploitationFileInputRef={deedOfExploitationFileInputRef}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            setTempFiles={setTempFiles}
          />
        );

      case 11:
        return (
          <FixedInstallationForm
            generateOptions={generateOptions}
            residentialUnitTypes={residentialUnitTypes}
            installationTypes={installationTypes}
            unitAttachments={unitAttachments}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            setDeclarationRequest={setDeclarationRequest}
            ownershipDeedFileInputRef={ownershipDeedFileInputRef}
            leaseContractFileInputRef={leaseContractFileInputRef}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            setTempFiles={setTempFiles}
          />
        );

      case 12:
        return (
          <VacantLandForm
            generateOptions={generateOptions}
            residentialUnitTypes={residentialUnitTypes}
            installationTypes={installationTypes}
            unitAttachments={unitAttachments}
            error_new_user={error_new_user}
            setValidFields={setValidFields}
            handleChangeDeclerationUnit={handleChangeDeclerationUnit}
            landOwnershipLegalDocument={landOwnershipLegalDocument}
            leaseContractFileInputRef={leaseContractFileInputRef}
            setError={setError}
            setUploadFileError={setUploadFileError}
            fileInputKeys={fileInputKeys}
            DownloadFile={handleDownloadFile}
            handlePreviewFile={handlePreviewFile}
            doYouWantExtraAttachments={doYouWantExtraAttachments}
            setBackendError={setBackendError}
            setSubmissionError={setSubmissionError}
            setTempFiles={setTempFiles}
          />
        );

      default:
        return <div></div>;
    }
  };

  useEffect(() => {
    renderRemainingFormBasedOnPropertyType();
  }, [declarationRequest?.unit?.property_type_id]);

  useEffect(() => {
    if (
      declarationRequest?.applicant_role_id &&
      (declarationRequest?.unit?.property_type_id === null ||
        declarationRequest?.unit?.property_type_id === "" ||
        declarationRequest?.unit?.property_type_id === undefined)
    ) {
      setError("property_type_id", "يجب اختيار نوع العقار");
    } else {
      setError("property_type_id", "");
    }
  }, [
    declarationRequest?.unit?.property_type_id,
    declarationRequest?.applicant_role_id,
  ]);

  const handleAddUnit = async () => {
    let isValid = true;
    resetDeclarationUnit();
    setIsUnitInSameBuilding(false);
    setBackendError(null);
    setSubmissionError(null);
    setUploadFileError(null);
    window.scrollTo(0, 0);

    if (
      declarationRequest?.taxpayer?.email !== "" &&
      declarationRequest?.taxpayer?.email !== null &&
      declarationRequest?.taxpayer?.email !== undefined
    ) {
      if (!validateEmail(declarationRequest?.taxpayer?.email)) {
        setError("email", "صيغة البريد الالكتروني غير صحيحة ");
        setValidFields((prev) => ({ ...prev, email: false }));
        isValid = false;
      } else {
        setError("email", "");
        setValidFields((prev) => ({ ...prev, email: true }));
      }
    }

    const isFormValid = validateBeforeSubmit(
      declarationRequest,
      validateRequired,
      setValidFields,
      setError,
      validateNationalIDWithoutAgeLimit,
      setUnitOwnerTypeErrorMessage,
      true,
    );

    const isValidPhone = validatePhoneBeforeSubmit(
      declarationRequest?.taxpayer?.phone || "20",
      declarationRequest?.taxpayer?.dial_code,
      declarationRequest?.taxpayer?.country_code,
      setPhoneError,
      declarationRequest?.taxpayer?.type_id,
      declarationRequest?.applicant_role_id,
      declarationRequest?.taxpayer?.nationality_id,
    );

    if (isFormValid && isValid && phoneError === null && isValidPhone) {
      try {
        const url = `api/declaration-system/declarations/check-duplicate-taxpayer`;
        const data = {
          applicant_role_id: declarationRequest?.applicant_role_id,
          national_id: declarationRequest?.taxpayer?.national_id,
          phone: declarationRequest?.taxpayer?.phone,
          passport_number: declarationRequest?.taxpayer?.passport_number,
          tax_card_number: declarationRequest?.taxpayer?.tax_card_number,
          commercial_register:
            declarationRequest?.taxpayer?.commercial_register,
          type_id: declarationRequest?.taxpayer?.type_id,
          declaration_id: declarationRequest?.id,
          applicant_national_id:
            declarationRequest?.applicant?.name ||
            user?.national_id ||
            user?.passport_number,
          applicant_phone:
            declarationRequest?.applicant?.profile?.mobile ||
            user?.phone_number,
        };
        await post(
          url,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        setDeclarationRequest({
          ...declarationRequest,
          unit: {
            ...getUnitInitialValue,
            property_type_id: declarationRequest?.unit?.property_type_id,
            unit_type_id: [2, 3, 4].includes(
              parseInt(declarationRequest?.unit?.property_type_id),
            )
              ? declarationRequest?.unit?.unit_type_id
              : null,
          },
          isShowOnlyUnit: true,
          activeTab: "residential",
        });
        clearAllUnitErrors();
      } catch (error) {
        setBackendError(error?.response?.data?.message || "حدث خطأ ما");
      }
    }
  };

  const renderDeclarationAndUnitHeader = () => {
    return declarationRequest?.isShowOnlyUnit &&
      declarationRequest?.isUnitViewMode
      ? "تفاصيل عقار"
      : declarationRequest?.isShowOnlyUnit && declarationRequest?.isUnitEditMode
        ? "تعديل عقار"
        : declarationRequest?.isShowOnlyUnit &&
            !declarationRequest?.isUnitEditMode &&
            !declarationRequest?.isUnitEditMode
          ? "اضافة عقار"
          : declarationRequest?.viewMode
            ? "تفاصيل الإقرار"
            : declarationRequest?.editMode
              ? "تعديل الإقرار"
              : "تقديم الإقرار";
  };

  const renderHeader = () => {
    switch (parseInt(declarationRequest?.unit?.property_type_id)) {
      case 1:
        return "بيانات الوحدة";

      case 2:
        return "بيانات الوحدة";

      case 3:
        return "بيانات الوحدة";

      case 4:
        return "بيانات الوحدة";

      case 5:
        return "بيانات المنشأة";

      case 6:
        return "بيانات المنشأة";

      case 7:
        return "بيانات المنشأة";

      case 8:
        return "بيانات المنشأة";

      case 9:
        return "بيانات المنشأة";

      case 10:
        return "بيانات المنشأة";

      case 11:
        return "بيانات التركيب ";

      case 12:
        return "بيانات الأرض الفضاء المستغلة";

      default:
        return "بيانات الوحدة / المنشأة";
    }
  };

  const handleBulkUpload = () => {
    let isValid = true;
    if (
      declarationRequest?.taxpayer?.phone !== "" &&
      declarationRequest?.taxpayer?.phone !== null &&
      declarationRequest?.taxpayer?.phone !== undefined &&
      declarationRequest?.taxpayer?.phone !==
        declarationRequest?.taxpayer?.dial_code
    ) {
      if (
        declarationRequest?.taxpayer?.country_code === "eg" &&
        !validateEgyptianPhoneNumberWithPhoneInput(
          declarationRequest?.taxpayer?.phone,
        ) &&
        declarationRequest?.taxpayer?.phone != "+20" &&
        declarationRequest?.taxpayer?.phone != "20"
      ) {
        setError("phone", "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول ");
        setValidFields((prev) => ({ ...prev, phone: false }));
        isValid = false;
      } else {
        setError("phone", "");
        setValidFields((prev) => ({ ...prev, phone: true }));
      }
    }

    if (
      declarationRequest?.taxpayer?.email !== "" &&
      declarationRequest?.taxpayer?.email !== null &&
      declarationRequest?.taxpayer?.email !== undefined
    ) {
      if (!validateEmail(declarationRequest?.taxpayer?.email)) {
        setError("email", "صيغة البريد الالكتروني غير صحيحة");
        setValidFields((prev) => ({ ...prev, email: false }));
        isValid = false;
      } else {
        setError("email", "");
        setValidFields((prev) => ({ ...prev, email: true }));
      }
    }
    const isFormValid = validateBeforeSubmit(
      declarationRequest,
      validateRequired,
      setValidFields,
      setError,
      validateNationalIDWithoutAgeLimit,
      setUnitOwnerTypeErrorMessage,
      true,
    );

    const isValidPhone = validatePhoneBeforeSubmit(
      declarationRequest?.taxpayer?.phone || "20",
      declarationRequest?.taxpayer?.dial_code,
      declarationRequest?.taxpayer?.country_code,
      setPhoneError,
      declarationRequest?.taxpayer?.type_id,
      declarationRequest?.applicant_role_id,
      declarationRequest?.taxpayer?.nationality_id,
    );

    if (isFormValid && isValid && phoneError === null && isValidPhone) {
      setIsBulkUpload(true);
    }
  };

  const handleBulkDelete = async () => {
    try {
      const response = await post(
        `api/declaration-system/declarations/${id}/bulk-delete?for_edit=true`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        },
      );
      setDeclarationRequest((prev) => ({
        ...prev,
        ...response?.data?.data,
      }));
      setShowModal(false);
    } catch (error) {
      setBackendError(
        error?.response?.data?.message || "حدث خطأ أثناء حذف العقارات",
      );
    }
  };

  return (
    <div
      className={
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode
          ? "hide-required-markers"
          : ""
      }
    >
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>هل أنت متأكد من حذف العقارات المختارة؟</h5>
          <div className="d-flex gap-4 justify-content-center">
            <button className="btn btn-primary px-3" onClick={handleBulkDelete}>
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => setShowModal(false)}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>
      {submissionError && (
        <div
          className="alert alert-danger  mt-3"
          id="backend_error"
          role="alert"
        >
          {Object.keys(submissionError).map((err, key) => (
            <li className="" key={key}>
              {submissionError[err][0]}
            </li>
          ))}
          {}
        </div>
      )}
      {uploadFileError && (
        <div
          className="alert alert-danger  mt-3"
          id="backend_error"
          role="alert"
        >
          {uploadFileError.map((i) => (
            <li className="" key={i}>
              {i}
            </li>
          ))}
          {}
        </div>
      )}
      {backendError && (
        <div
          className="alert alert-danger mt-3"
          id="backend_error"
          role="alert"
        >
          {backendError}
        </div>
      )}

      {/* TODO decleration details section  */}

      {
        // declarationRequest?.declaration_number &&
        declarationRequest?.viewMode && !declarationRequest?.isShowOnlyUnit && (
          <div className={`${stylesRequestData.box} box pdf-box`}>
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
              بيانات الإقرار
            </h4>
            <div className="row">
              <DeclerationInfo />
            </div>
          </div>
        )
      }

      {!declarationRequest?.isShowOnlyUnit && (
        <Fragment>
          <div className={`${stylesRequestData.box} box pdf-box`}>
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
              بيانات مقدم الإقرار
            </h4>
            <UserForm
              generateOptions={generateOptions}
              handleChangeApplicantRole={handleChangeApplicantRole}
              applicantRoles={applicantRoles}
              error_new_user={error_new_user}
              fileInputKeys={fileInputKeys}
              handleChangeFile={handleChangeFile}
              handleChange={handleChange}
              user={user}
              setError={setError}
              nationalIdFileInputRef={nationalIdFileInputRef}
              passportNumFileInputRef={passportNumFileInputRef}
              commercialRegistrationNumberInputRef={
                commercialRegistrationNumberInputRef
              }
              taxNumberFileInputRef={taxNumberFileInputRef}
              otherEntityFileInputRef={otherEntityFileInputRef}
            />
          </div>
          {[2, 5, 6, 7].includes(
            parseInt(declarationRequest?.applicant_role_id),
          ) && (
            <>
              <TaxPayerForm
                generateOptions={generateOptions}
                unitOwnerTypeErrorMessage={unitOwnerTypeErrorMessage}
                taxpayerTypes={taxpayerTypes}
                error_new_user={error_new_user}
                nationalitesOptions={nationalitesOptions}
                validateRequired={validateRequired}
                setError={setError}
                setValidFields={setValidFields}
                setUploadFileError={setUploadFileError}
                handleNationalityChange={handleNationalityChange}
                handleTypeOneChange={handleTypeOneChange}
                handleTypeTwoChange={handleTypeTwoChange}
                setTempFiles={setTempFiles}
              />
            </>
          )}
        </Fragment>
      )}

      {declarationRequest?.viewMode && !declarationRequest?.isShowOnlyUnit && (
        <>
          <div className={`${stylesRequestData.box} box pdf-box`}>
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
              قائمة المستندات الإلزامية لمقدم الطلب والمكلف بأداء الضريبة لتقديم
              الإقرار
            </h4>
            <div className="row">
              <UserAndTaxPayerDetailFiles user={user} />
            </div>
          </div>
        </>
      )}

      {declarationRequest?.isShowOnlyUnit && (
        <>
          <div className="d-flex align-items-center mb-4">
            <button
              className={`${stylesRequestData["btn-arrow"]} ms-3`}
              onClick={() => {
                setIsUnitInSameBuilding(false);
                setDeclarationRequest({
                  ...declarationRequest,
                  isShowOnlyUnit: false,
                  isUnitEditMode: false,
                  isUnitViewMode: false,
                  isDeclarationSameUnit: false,
                });
                setBuilding(null);
                setIsBuildingEditMode(false);
                if (
                  declarationRequest?.id &&
                  location?.pathname?.includes("details")
                ) {
                  setIsGoingToFetchDeclarationData(true);
                  navigate(
                    `/tax-declaration/details/${declarationRequest?.id}`,
                  );
                }

                if (
                  declarationRequest?.id &&
                  location?.pathname?.includes("update")
                ) {
                  setIsGoingToFetchDeclarationData(true);
                  navigate(`/tax-declaration/update/${declarationRequest?.id}`);
                }
                clearAllUnitErrors();
              }}
            >
              <i className="fa-solid fa-arrow-right mt-1"></i>
            </button>

            <h4
              className={`${stylesRequestData["box-title"]} box-title mb-0 ms-2`}
            >
              {renderDeclarationAndUnitHeader()}
            </h4>
          </div>
        </>
      )}

      {/* {(declarationRequest?.viewMode && declarationRequest?.unit?.id) ||
        (!declarationRequest?.viewMode && ( */}
      <div className="box pdf-box">
        <div>
          {(declarationRequest?.editMode ||
            location?.pathname?.includes("add")) &&
            !declarationRequest?.isShowOnlyUnit && (
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
                <h4
                  className={`${stylesRequestData["box-title"]} box-title col-12 col-md-3`}
                >
                  تفاصيل العقارات
                </h4>
                <div className="d-flex flex-column flex-sm-row gap-3 mt-3 mt-md-0 col-12 col-md-9 justify-content-end">
                  {!declarationRequest?.viewMode &&
                    !declarationRequest?.isUnitViewMode && (
                      <button
                        onClick={handleAddUnit}
                        className={`${
                          declarationRequest?.unit?.property_type_id &&
                          declarationRequest?.unit?.property_type_id !== null
                            ? stylesRequestData["btn-request"]
                            : stylesRequestData["btn-request-disabled"]
                        }`}
                      >
                        إضافة عقار جديد
                      </button>
                    )}
                  {parseInt(declarationRequest?.taxpayer?.type_id) === 2 && (
                    <>
                      <button
                        onClick={handleBulkUpload}
                        className={`${stylesRequestData["btn-request-long"]}`}
                      >
                        رفع مجمع للوحدات السكنية والغير سكنيه
                      </button>
                    </>
                  )}
                  {/* {parseInt(declarationRequest?.status_id) === 1 && (
                    <button
                      onClick={() => setShowModal(true)}
                      className={`${stylesRequestData["btn-delete-all"]} btn btn-danger`}
                    >
                      مسح جميع العقارات
                    </button>
                  )} */}
                </div>
              </div>
            )}

          <div className="row">
            {/* TODO handle all condtions */}
            {(declarationRequest?.editMode ||
              location?.pathname?.includes("add") ||
              (declarationRequest?.viewMode &&
                declarationRequest?.unit?.id &&
                declarationRequest?.isShowOnlyUnit)) && (
              <>
                {declarationRequest?.isShowOnlyUnit && (
                  <div className="col-12">
                    <h4
                      className={`${stylesRequestData["box-title"]} box-title`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      بيانات الموقع
                      {declarationRequest?.isShowOnlyUnit &&
                        !declarationRequest?.isUnitViewMode && (
                          //todo
                          <InfoPopover content="يرجى تحديد موقع العقار بدقة بإستخدام الخريطة و محددات البحث سواء باستخدام العنوان التنظيمي أو هيئة المجتمعات العمرانية لتسهيل عملية البحث">
                            <img
                              src={infoIconSvg}
                              alt="info"
                              width="18"
                              height="18"
                              style={{ display: "block" }}
                            />
                          </InfoPopover>
                        )}
                      {declarationRequest?.isShowOnlyUnit &&
                        declarationRequest?.isUnitViewMode &&
                        [5, 6, 7, 8, 9].includes(
                          parseInt(declarationRequest?.unit?.property_type_id),
                        ) && (
                          <InfoPopover content="هذا العنوان هو عنوان المبنى الرئيسي للمنشأة">
                            <img
                              src={infoIconSvg}
                              alt="info"
                              width="18"
                              height="18"
                              style={{ display: "block" }}
                            />
                          </InfoPopover>
                        )}
                    </h4>
                  </div>
                )}
                <div className="col-lg-4 col-sm-6">
                  <SearchSelectElement
                    mb4="mb-4"
                    labelHtmlFor="property_type_id"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="نوع العقار"
                    selectClassName={`${stylesRequestData["form-select"]} form-select`}
                    selectID="property_type_id"
                    inputId="uproperty_type_input"
                    name="property_type_id"
                    options={generateOptions(propertyTypes)}
                    default="أختار نوع العقار .."
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    pText={error_new_user.property_type_id}
                    value={declarationRequest?.unit?.property_type_id}
                    onChange={handleChangeDeclerationUnit}
                    isClearable={true}
                    disabled={
                      declarationRequest?.viewMode ||
                      declarationRequest?.isUnitViewMode ||
                      declarationRequest?.isUnitEditMode ||
                      declarationRequest?.isShowOnlyUnit ||
                      declarationRequest?.applicant_role_id === null ||
                      error_new_user?.applicant_role_id != ""
                    }
                  />
                </div>
              </>
            )}

            {declarationRequest?.isShowOnlyUnit && (
              <>
                <CommonAddressForm
                  generateOptions={generateOptions}
                  govs={govs}
                  error_new_user={error_new_user}
                  handleChange={handleChange}
                  setError={setError}
                  setValidFields={setValidFields}
                  setUploadFileError={setUploadFileError}
                  setFloors={setFloors}
                  setUnits={setUnits}
                  setNewUserError={setNewUserError}
                  handleChangeDeclerationUnit={handleChangeDeclerationUnit}
                  mapInitializedRef={mapInitializedRef}
                  setUnitMapError={setUnitMapError}
                  unitMapError={unitMapError}
                />

                {/* <h4 className={`${stylesRequestData["box-title"]} box-title`}>
                  بيانات الوحدة/ المنشأة{" "}
                </h4> */}

                <div className="d-inline-flex">
                  <h4 className={`${stylesRequestData["box-title"]} box-title`}>
                    {renderHeader()}{" "}
                  </h4>
                  {parseInt(declarationRequest?.unit?.property_type_id) ===
                    11 && (
                    <>
                      <InfoPopover content="تحديد مكان التركيب بحسب الدور المثبت عليه التركيب وفي حاله تثبيته على واجهة العقار يتم اختيار اخري ويدرج واجهه أو سطح.">
                        <img
                          src={infoIconSvg}
                          alt="info"
                          width="18"
                          height="18"
                          style={{
                            display: "block",
                            marginTop: "8px",
                            marginRight: "16px",
                          }}
                        />
                      </InfoPopover>
                    </>
                  )}
                </div>

                {[1, 2, 3, 4, 11].includes(
                  parseInt(declarationRequest?.unit?.property_type_id),
                ) && (
                  <>
                    {/* <h4
                      className={`${stylesRequestData["box-title"]} box-title`}
                    >
                      بيانات الوحدة
                    </h4> */}
                    <div className="col-lg-4 col-sm-6">
                      <SearchSelectElement
                        mb4="mb-4"
                        labelHtmlFor="real_estate_floor_id"
                        labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                        labelText="رقم الدور"
                        selectClassName={`${stylesRequestData["form-select"]} form-select`}
                        selectID="real_estate_floor_id"
                        inputId="real_estate_floor_id_input"
                        name="real_estate_floor_id"
                        options={
                          !hasUnitAddress &&
                          parseInt(
                            declarationRequest?.unit?.filter_search_type_id,
                          ) !== 3
                            ? []
                            : generateOptions(realFloorOther)
                        }
                        default="أختار رقم رقم الدور.."
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={error_new_user.real_estate_floor_id}
                        value={parseInt(
                          declarationRequest?.unit?.real_estate_floor_id,
                        )}
                        onChange={handleChangeDeclerationUnit}
                        isClearable={true}
                        disabled={
                          declarationRequest?.viewMode ||
                          declarationRequest?.isUnitViewMode
                        }
                      />
                    </div>
                    {parseInt(
                      declarationRequest?.unit?.real_estate_floor_id,
                    ) === -1 && (
                      <div className="col-lg-4 col-sm-6">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="real_estate_floor_other"
                          labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                          labelText="رقم الدور الآخر"
                          inputType="text"
                          maxLength={100}
                          inputClassName={`${stylesRequestData["form-control"]} form-control`}
                          inputID="real_estate_floor_other_input"
                          name="real_estate_floor_other"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={
                            declarationRequest?.unit?.real_estate_floor_other ||
                            ""
                          }
                          allowedPattern={
                            /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.+،\/\\\s]+$/
                          }
                          onChange={handleChangeDeclerationUnit}
                          pText={error_new_user.real_estate_floor_other}
                          isClearable={true}
                          disabled={
                            declarationRequest?.viewMode ||
                            declarationRequest?.isUnitViewMode
                          }
                        />
                      </div>
                    )}
                    {parseInt(declarationRequest?.unit?.property_type_id) !==
                      11 && (
                      <div className="col-lg-4 col-sm-6">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="unit_number"
                          labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                          labelText="رقم الوحدة"
                          inputType="text"
                          maxLength={100}
                          inputClassName={`${stylesRequestData["form-control"]} form-control`}
                          inputID="unit_number_input"
                          name="unit_number"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={declarationRequest?.unit?.unit_number || ""}
                          allowedPattern={
                            /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.،\/\\\s]+$/
                          }
                          onChange={handleChangeDeclerationUnit}
                          pText={error_new_user.unit_number}
                          isClearable={true}
                          disabled={
                            (!hasUnitAddress &&
                              parseInt(
                                declarationRequest?.unit?.filter_search_type_id,
                              ) !== 3) ||
                            declarationRequest?.viewMode ||
                            declarationRequest?.isUnitViewMode
                          }
                        />
                      </div>
                    )}
                  </>
                )}

                {parseInt(declarationRequest?.unit?.property_type_id) !==
                  12 && (
                  <>
                    <div className="col-lg-4 col-sm-6">
                      <SearchSelectElement
                        mb4="mb-4"
                        labelHtmlFor="reta_contact_about_unit"
                        labelClassName={` required form-label ${stylesRequestData["form-label"]} ${stylesRequestData["smaller-label"]}`}
                        labelText="هل تم التواصل مع الضرائب العقارية بخصوص الوحدة محل الإقرار سابقا؟"
                        selectClassName={`${stylesRequestData["form-select"]} form-select `}
                        selectID="reta_contact_about_unit"
                        inputId="reta_contact_about_unit_input"
                        name="reta_contact_about_unit"
                        options={generateOptions(doYouWantExtraAttachments)}
                        default="أختار هل تم التواصل؟ .."
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={error_new_user.reta_contact_about_unit}
                        value={parseInt(
                          declarationRequest?.unit?.reta_contact_about_unit,
                        )}
                        onChange={handleChangeDeclerationUnit}
                        isClearable={true}
                        style={{ fontSize: "14px !important" }}
                        disabled={
                          declarationRequest?.viewMode ||
                          declarationRequest?.isUnitViewMode
                        }
                      />
                    </div>
                    {parseInt(
                      declarationRequest?.unit?.reta_contact_about_unit,
                    ) === 1 && (
                      <div className="col-lg-4 col-sm-6">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="account_code"
                          labelClassName={`${stylesRequestData["form-label"]} form-label`}
                          labelText="كود حساب الوحدة"
                          inputType="text"
                          maxLength={14}
                          inputClassName={`${stylesRequestData["form-control"]} form-control`}
                          inputID="account_code_input"
                          name="account_code"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={declarationRequest?.unit?.account_code || ""}
                          allowedPattern={/^[0-9]+$/}
                          onChange={handleChangeDeclerationUnit}
                          pText={error_new_user.account_code}
                          isClearable={true}
                          disabled={
                            declarationRequest?.viewMode ||
                            declarationRequest?.isUnitViewMode
                          }
                        />
                      </div>
                    )}
                  </>
                )}

                {renderRemainingFormBasedOnPropertyType()}

                <div className="">
                  <div className="col-lg-4 col-sm-6">
                    <SearchSelectElement
                      mb4="mb-4"
                      labelHtmlFor="submit_other_supporting_documents"
                      labelClassName={` required form-label ${stylesRequestData["form-label"]} mt-2`}
                      labelText="هل ترغب في تحميل المستندات الإضافية الداعمة للطلب؟"
                      selectClassName={`${stylesRequestData["form-select"]} form-select`}
                      selectID="submit_other_supporting_documents"
                      inputId="submit_other_supporting_documents_input"
                      name="submit_other_supporting_documents"
                      options={generateOptions(doYouWantExtraAttachments)}
                      default="أختار.."
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      pText={error_new_user.submit_other_supporting_documents}
                      value={parseInt(
                        declarationRequest?.unit
                          ?.submit_other_supporting_documents,
                      )}
                      onChange={handleChangeDeclerationUnit}
                      isClearable={true}
                      disabled={
                        declarationRequest?.viewMode ||
                        declarationRequest?.isUnitViewMode
                      }
                    />
                  </div>
                </div>
                {parseInt(
                  declarationRequest?.unit?.submit_other_supporting_documents,
                ) === 1 &&
                  declarationRequest?.unit?.supporting_documents?.length >
                    0 && (
                    <>
                      {declarationRequest?.unit?.supporting_documents?.map(
                        (document, index) => {
                          return (
                            <div className="row mt-3 mt-md-0" key={document.id}>
                              <div className="col-12 col-md-4">
                                <InputElement
                                  value={document.name || ""}
                                  name="name"
                                  onChange={(e) => {
                                    updateDocumentName(
                                      document.id,
                                      e?.target?.value,
                                    );
                                  }}
                                  mb4="mb-4"
                                  labelHtmlFor="name"
                                  labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                                  labelText="اسم المستند"
                                  inputType="text"
                                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                                  inputID="document_name_input"
                                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                  pText={fileErrors[document.id]?.name || ""}
                                  allowedPattern={
                                    /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                                  }
                                  maxLength={100}
                                  customChange={true}
                                  disabled={
                                    declarationRequest?.viewMode ||
                                    declarationRequest?.isUnitViewMode
                                  }
                                />
                              </div>

                              {!declarationRequest?.viewMode &&
                                !declarationRequest?.isUnitViewMode && (
                                  <div className="col-12 col-md-4 ">
                                    <InputElement
                                      key={inputKeys[document.id] || 0}
                                      fileInputRef={
                                        documentFileInputRef.current[
                                          document.id
                                        ]
                                      }
                                      labelHtmlFor="file"
                                      labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                                      labelText="اختيار ملف"
                                      name="file"
                                      inputType="file"
                                      fileName={
                                        declarationRequest?.unit?.supporting_documents?.find(
                                          (item) => item.id === document.id,
                                        )?.original_file_name || "إرفاق ملف"
                                      }
                                      inputID={`document_file_input_${document.id}`}
                                      inputClassName={`${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                                      inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                                      icon="fa-solid fa-cloud-arrow-up"
                                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                      pText={
                                        fileErrors[document.id]?.file || ""
                                      }
                                      onChange={async (
                                        parent,
                                        component,
                                        name,
                                        file,
                                        i,
                                        bi,
                                        fi,
                                        ref,
                                      ) => {
                                        if (file) {
                                          if (!validateRequired(file)) {
                                            setFileErrorById(
                                              document.id,
                                              "name",
                                              "يجب رفع الصورة",
                                            );
                                            return;
                                          }

                                          setFileErrorById(
                                            document.id,
                                            "name",
                                            "",
                                          );
                                          setFileErrorById(
                                            document.id,
                                            "file",
                                            "",
                                          );

                                          updateDocumentFile(
                                            document.id,
                                            file,
                                            ref,
                                          );
                                        }
                                      }}
                                      accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                                      disabled={
                                        !validateRequired(document.name) ||
                                        declarationRequest?.viewMode ||
                                        declarationRequest?.isUnitViewMode
                                      }
                                      deleteFunction={() =>
                                        handleRemoveFileForAdditionalAttachment(
                                          document?.id,
                                        )
                                      }
                                    />
                                  </div>
                                )}

                              {!declarationRequest?.viewMode &&
                                !declarationRequest?.isUnitViewMode && (
                                  <div className=" col-sm-4 row gap-2">
                                    <div className="col-md-5 col-sm-6 ">
                                      {!declarationRequest?.viewMode &&
                                        !declarationRequest?.isUnitViewMode &&
                                        declarationRequest?.unit
                                          ?.supporting_documents?.length > 1 &&
                                        index !== 0 && (
                                          <button
                                            onClick={() =>
                                              removeAttachmentById(document.id)
                                            }
                                            className={` ${stylesRequestData["btn-delete"]} text-danger`}
                                            style={{ marginTop: "33px" }}
                                          >
                                            حذف المستند{" "}
                                            <i className="fa-regular fa-trash-can fa-lg ml-1"></i>
                                          </button>
                                        )}
                                    </div>
                                    {!declarationRequest?.viewMode &&
                                      !declarationRequest?.isUnitViewMode &&
                                      index ===
                                        declarationRequest?.unit
                                          ?.supporting_documents.length -
                                          1 && (
                                        <div className="col-md-5 col-sm-6 ">
                                          <button
                                            onClick={() => addAttachment()}
                                            className={` ${
                                              !validateRequired(
                                                document.name,
                                              ) ||
                                              !validateRequired(
                                                document.full_url,
                                              ) ||
                                              declarationRequest?.unit
                                                ?.supporting_documents
                                                .length === 5 ||
                                              declarationRequest?.viewMode ||
                                              declarationRequest?.isUnitViewMode
                                                ? stylesRequestData[
                                                    "btn-add-disabled"
                                                  ]
                                                : stylesRequestData["btn-add"]
                                            } `}
                                            style={{ marginTop: "33px" }}
                                          >
                                            إضافة مستند آخر
                                          </button>
                                        </div>
                                      )}
                                  </div>
                                )}

                              {document?.full_url &&
                                (declarationRequest?.viewMode ||
                                  declarationRequest?.isUnitViewMode) && (
                                  <div className="col-md-4 col-sm-6">
                                    <label
                                      htmlFor="document_file_value"
                                      labelHtmlFor="document_file_value"
                                      className={`${stylesRequestData["form-label"]} form-label`}
                                    >
                                      صورة المرفق
                                    </label>
                                    <div
                                      className=" col-2-4 d-flex border border-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-2 px-2 align-items-center mb-3"
                                      name="document_file_value"
                                    >
                                      <p
                                        className="mb-0 file-name fs-6"
                                        title={document?.original_file_name}
                                      >
                                        {document?.original_file_name}
                                      </p>
                                      {!declarationRequest?.viewMode &&
                                      !declarationRequest?.isUnitViewMode ? (
                                        <div className="d-flex align-items-center py-2">
                                          {/* <span
                                          type="button"
                                          onClick={() =>
                                            handleRemoveFileForAdditionalAttachment(
                                              document?.id,
                                            )
                                          }
                                          className={`text-danger border-0`}
                                        >
                                          <i className="fa-solid fa-trash fa-lg px-2"></i>
                                        </span> */}
                                        </div>
                                      ) : (
                                        <div className="d-flex align-items-center py-2">
                                          <span
                                            type="button"
                                            onClick={() =>
                                              handlePreviewFile(
                                                document?.full_url,
                                              )
                                            }
                                            className={`text-danger border-0`}
                                          >
                                            <i
                                              className="fa-slab-press fa-regular fa-eye fa-lg px-2"
                                              style={{ color: "#32A8ED" }}
                                            ></i>
                                          </span>
                                          <span
                                            type="button"
                                            onClick={() =>
                                              handleDownloadFile(
                                                document?.full_url,
                                              )
                                            }
                                            className={`text-danger border-0`}
                                          >
                                            <i
                                              className="fa-solid fa-cloud-arrow-down fa-lg px-2"
                                              style={{ color: "#32A8ED" }}
                                            ></i>
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                            </div>
                          );
                        },
                      )}
                    </>
                  )}
                <div className="d-flex flex-lg-row flex-column justify-content-start  gap-3  align-items-center pb-5 mt-5">
                  {!declarationRequest?.viewMode &&
                    !declarationRequest?.isUnitViewMode && (
                      <button
                        type="button"
                        className={` ${
                          disableSubmitButtonCheck() ||
                          isButtonDisabledIfAttachmentFilesAreNotValid
                            ? stylesRequestData["btn-request-disabled"]
                            : stylesRequestData["btn-request"]
                        } `}
                        onClick={handleSubmitUnit}
                        id="submit_request_data"
                        disabled={isSubmitting}
                      >
                        {declarationRequest?.isUnitEditMode &&
                        !declarationRequest?.isDeclarationSameUnit
                          ? "حفظ التعديلات"
                          : "حفظ البيانات"}
                      </button>
                    )}

                  {[1, 2, 3, 4, 11].includes(
                    parseInt(declarationRequest?.unit?.property_type_id),
                  ) &&
                    ([1, 2, 3].includes(
                      parseInt(declarationRequest?.status_id),
                    ) ||
                      location?.pathname.includes("add")) &&
                    (location?.pathname.includes("add") ||
                      (location?.pathname.includes("update") &&
                        !declarationRequest?.isUnitEditMode)) && (
                      <button
                        type="button"
                        className={` ${
                          disableSubmitButtonCheck() ||
                          isButtonDisabledIfAttachmentFilesAreNotValid
                            ? stylesRequestData["btn-request-long-disabled"]
                            : stylesRequestData["btn-request-long"]
                        } `}
                        onClick={handleSubmitSameUnit}
                        id="submit_request_data"
                        disabled={isSubmitting}
                        // style={{ width: "30%" }}
                      >
                        <i className="fa-solid fa-plus fa-lg ps-2"></i>
                        حفظ واضافة وحدة اخرى بذات العقار
                      </button>
                    )}

                  {!declarationRequest?.viewMode &&
                    !declarationRequest?.isUnitViewMode && (
                      <button
                        type="button"
                        onClick={() => {
                          setIsUnitInSameBuilding(false);
                          setDeclarationRequest({
                            ...declarationRequest,
                            isShowOnlyUnit: false,
                            isUnitEditMode: false,
                            isUnitViewMode: false,
                          });
                          if (declarationRequest?.id) {
                            navigate(
                              `/tax-declaration/update/${declarationRequest?.id}`,
                            );
                          }
                        }}
                        className={`${stylesRequestData["btn-delete"]}`}
                        // className="btn btn-outline-danger "
                        id="cancel_request_data"
                        disabled={isSubmitting}
                      >
                        إلغاء
                      </button>
                    )}
                </div>
                {checkIfBuildingsFilterIsEqualToUnitFilterType !== "" && (
                  <h4 className="fs-5">
                    {checkIfBuildingsFilterIsEqualToUnitFilterType}
                  </h4>
                )}
              </>
            )}
          </div>

          {!declarationRequest?.viewMode &&
            !declarationRequest?.isShowOnlyUnit && (
              <>
                {showDeleteSuccessMessage && (
                  <div className="alert alert-success text-success mt-2 text-center w-50 mx-auto">
                    <h3 className="fs-5">تم حذف العقار بنجاح</h3>
                  </div>
                )}
                <CommonTabs onDeleteSuccess={handleDeleteUnitSuccess} />
              </>
            )}

          {!declarationRequest?.isShowOnlyUnit &&
            declarationRequest?.viewMode && <CommonLists />}
        </div>
      </div>
      {/* ))} */}

      {!declarationRequest?.isShowOnlyUnit && !declarationRequest?.viewMode && (
        <div className="box pdf-box">
          <div className="d-inline-flex">
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
              إقرار بصحة البيانات{" "}
            </h4>
            <InfoPopover
              content="الإقرار بصحة البيانات يرد علي كافة البيانات المدخلة سواء التي يتم استدعائها من الخريطة أو المدخلة في وصف المبني.
وفي حالة عدم وجود العقار علي الخريطة واختيار اقرب عقار أو اختلاف البيانات التي تم استدعائها من الخريطة يقتصر الإقرار بصحة البيانات علي البيانات المدخلة بوصف المبني.  
"
            >
              <img
                src={infoIconSvg}
                alt="info"
                width="18"
                height="18"
                style={{
                  display: "block",
                  marginTop: "8px",
                  marginRight: "16px",
                }}
              />
            </InfoPopover>
          </div>
          <div className="row mb-4">
            <div className="list-group border-0">
              <label
                htmlFor="date"
                className={`required ${stylesRequestData["list-group-item"]} list-group-item border-0`}
              >
                <input
                  type="checkbox"
                  className={`${stylesRequestData["form-check-input"]} form-check-input ms-3 `}
                  name="data_accuracy_declaration"
                  id="data_accuracy_declaration"
                  checked={declarationRequest?.data_accuracy_declaration}
                  onChange={(e) => {
                    handleChange(
                      "",
                      "",
                      "data_accuracy_declaration",
                      e.target.checked ? 1 : 0,
                    );
                    setNewUserError((prev) => ({
                      ...prev,
                      data_accuracy_declaration: "",
                    }));
                    if (
                      !e.target.checked &&
                      parseInt(declarationRequest?.status_id) !== 1
                    ) {
                      setNewUserError((prev) => ({
                        ...prev,
                        data_accuracy_declaration:
                          "يجب أن تقر بأن البيانات الواردة بالإقرار الضريبي صحيحة و مطابقة للواقع، كما أقر بمسؤوليتي القانونية في حالة الإدلاء ببيانات خاطئة بهذا الإقرار أو تقديم مستندات غير صحيحة",
                      }));
                    }
                  }}
                  style={{
                    marginTop: "-2px",
                  }}
                />
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  {
                    "أقر أنا بأن البيانات الواردة بالإقرار الضريبي صحيحة و مطابقة للواقع، كما أقر بمسؤوليتي القانونية في حالة الإدلاء ببيانات خاطئة بهذا الإقرار أو تقديم مستندات غير صحيحة"
                  }
                </span>
              </label>

              {error_new_user.data_accuracy_declaration && (
                <p
                  className="text-danger mb-0 mt-1 me-4 fw-bolder"
                  id="acknowledge_tax_period_error"
                >
                  {error_new_user.data_accuracy_declaration}
                </p>
              )}
            </div>
          </div>
          {/* <button
            type="button"
            className={`${stylesRequestData["btn-request"]} mt-4 `}
            onClick={() => navigate(`/tax-declaration/list-data`)}
            id="back_to_list"
          >
            العودة
          </button> */}
        </div>
      )}
    </div>
  );
};

export default UnifiedTaxDeclarationData;
